import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails
} from '../../interfaces/apiInterfaces';

export class GetDriverInfoByIdCommand extends IRequestCommand<
  IGetDriverInfoByIdResponse,
  ErrorDetails,
  IGetDriverInfoByIdCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/{driverId}/dashboard/driver';
  public override setParameters(parameters: IGetDriverInfoByIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );

    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.driverId.toString()
    );
  }
}

export interface IGetDriverInfoByIdCommandParameters extends ICommandParameters {
  carrierUserId: number;
  driverId?: number;
}

export interface IGetDriverInfoByIdResponse extends ICommandResponse { }
